import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/main.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import { filters } from './filters/filters'

// Registrar filtros globalmente
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
